import { createAction } from "typesafe-actions";

import type {
  FiCatalogResponse,
  FiChartSettings,
} from "@mapmycustomers/shared/types/entity/fieldInsight";

export const fetchFieldInsightsChartVisibility = createAction(
  "@fieldInsightsChartVisibility/fetch"
)<{
  callback: (charts: FiCatalogResponse[]) => void;
  displayNotification?: boolean;
  failureCallback?: () => void;
}>();

export const updateFieldInsightsChartVisibility = createAction(
  "@fieldInsightsChartVisibility/update"
)<{
  callback: () => void;
  charts: FiChartSettings[];
  failureCallback?: () => void;
}>();
